import styled from 'styled-components';
import UIAccordionItem from 'UIComponents/accordion/UIAccordionItem';
import useAccordionOpenState from 'ContentEditorUI/hooks/useAccordionOpenState';
import { jsx as _jsx } from "react/jsx-runtime";
export const TitleWrapper = styled.span.withConfig({
  displayName: "InpageSectionAccordion__TitleWrapper",
  componentId: "jin072-0"
})([".hs-private.hs-private.hs-private &{font-size:14px;}"]);
const InpageSectionAccordion = ({
  children,
  title,
  type
}) => {
  const storageKey = `addSectionAccordion-${type}.isOpen`;
  function getInitialOpenState(storedOpenState) {
    return Boolean(storedOpenState && storedOpenState === 'true' || storedOpenState === null);
  }
  const {
    isOpen,
    handleOpenChange
  } = useAccordionOpenState({
    storageKey,
    getInitialOpenState
  });
  return /*#__PURE__*/_jsx(UIAccordionItem, {
    title: title,
    size: "small",
    className: "m-bottom-5",
    titleClassName: "accordion-header-with-demphasized-small-styles",
    contentClassName: "force-left-flush-accordion-content",
    open: isOpen,
    onOpenChange: handleOpenChange,
    "data-test-id": `add-module-group-${type}`,
    children: children
  });
};
export default InpageSectionAccordion;